<div id="footer-container-inner" class="footer-container-inner none">
  <div class="footer-box footer-region first-footer">
    <section id="block-logoblack">
      <div class="logo-wrapper">
        <img alt="logo white" src="assets/img/design-2026/logical-logo.png" width="140">
      </div>
    </section>
  </div>

  <div class="footer-box footer-region second-footer">
    <section id="block-udajefirmylogicalfinance">
      <div>
        <p class="text-align-center">{{ "WebAddressFooter1" | translate }}</p>
        <p class="text-align-center">{{ "WebAddressFooter2" | translate }}</p>
      </div>
    </section>
  </div>

  <div class="footer-box footer-region third-footer">
    <section id="block-socialnisite">
      <div class="field field--name-body field--type-text-with-summary field--label-hidden field__item">
        <p>
          <a href="https://www.facebook.com/Logical-109550177144580/">
            <img alt="facebook logo" class="facebook" height="40"
              src="/assets/img/Facebook-icon-isolated-on-transparent-background-PNG_0.png" width="40"
              loading="lazy">
          </a>
        </p>
      </div>
    </section>
  </div>
</div>

<ul role="menu" class="ul-parent-footer">
  <li class="li-item li-item-footer li-item-footer-left li-0" role="none">
    <a href="/informace-o-cookies" class="li-link li-link-footer" role="menuitem">Informace o cookies</a>
  </li>
  <li class="li-item li-item-footer li-item-footer-center li-0" role="none">
    <a href="/obchodni-podminky" class="li-link li-link-footer" role="menuitem">Obchodní podmínky</a>
  </li>
  <li class="li-item li-item-footer li-item-footer-right li-0" role="none">
    <a href="/ochrana-osobnich-udaju" class="li-link li-link-footer" role="menuitem">Ochrana osobních údajů</a>
  </li>
</ul>

<div class="footer-copyright">
  <p>2019 - {{ currentYear }} © Logical, s.r.o.</p>
</div>
